import reviewStatuses from '@/util/reviewStatuses'

export default {
  reviewStatusOptions () {
    return Object.keys(reviewStatuses).map(key => {
      return {
        label: reviewStatuses[key],
        value: key,
      }
    })
  },
}
